class B2BSwitcher extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'audocph_b2b_mode';
    this.buttons = this.querySelectorAll('[data-b2b-mode]');
    this.init();
  }

  init() {
    const savedMode = localStorage.getItem(this.STORAGE_KEY) || 'privat';
    this.setActiveMode(savedMode, false);

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const mode = e.currentTarget.dataset.b2bMode;
        const landingPage = e.currentTarget.dataset.landingPage;

        localStorage.setItem(this.STORAGE_KEY, mode);
        this.setActiveMode(mode, true);

        // Dispatch event for header to swap menus
        document.dispatchEvent(
          new CustomEvent('b2b:mode-changed', { detail: { mode } })
        );

        // Navigate to landing page on first click to professionals
        if (landingPage && window.location.pathname !== landingPage) {
          window.location.href = landingPage;
        }
      });
    });
  }

  setActiveMode(mode, broadcast) {
    this.buttons.forEach((btn) => {
      const isActive = btn.dataset.b2bMode === mode;
      btn.classList.toggle('b2b-switcher__btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Update all other switchers on the page
    if (broadcast) {
      document.querySelectorAll('[data-b2b-switcher]').forEach((switcher) => {
        if (switcher !== this) {
          switcher.querySelectorAll('[data-b2b-mode]').forEach((btn) => {
            const isActive = btn.dataset.b2bMode === mode;
            btn.classList.toggle('b2b-switcher__btn--active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
      });
    }

    // Swap menu visibility class on <html> (mirrors the inline script that runs before render)
    document.documentElement.classList.toggle('b2b-professional', mode === 'professional');
    document.documentElement.classList.toggle('b2b-private', mode !== 'professional');
  }
}

customElements.define('b2b-switcher', B2BSwitcher);
